import { IMultiOccurrenceOptions, IMultiOccurrence } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IStateParamsService } from 'angular-ui-router';
import { IPaginationClass } from '../../../../../core/services/pagination.service';

interface IPageCp0035 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
    multiOccurrence: IMultiOccurrence;
    fcaMultiOccurrenceOptions: IMultiOccurrenceOptions;
}
/* @ngInject */
export default function Cp0035Controller(Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    Pagination: IPaginationClass,
    $stateParams: IStateParamsService ) {
    const vm: IPageCp0035 = this;

    vm.fcaMultiOccurrenceOptions = {
        bloc: 'fca',
        pagination: new Pagination({
            nombreElementPage: 5,
            nbElementsPossibles: [5, 10, 15]
        }),
        colonnesVisibles: [
            { nom: 'fcanum', largeur: 200 },
            { nom: 'fcanomdet', largeur: 200 },
            { nom: 'fcaflgstu', largeur: 120 },
            { nom: 'intcod', largeur: 120 },
            { nom: 'intnom', largeur: 180 }
        ],
        formulaire: new Formulaire([
            new FormulaireItem('fcanum'),
            new FormulaireItem('fcanomdet'),
            new FormulaireItem('fcaflgstu'),
            new FormulaireItem('intcleint')
        ])
    };

    vm.multiOccurrenceOptions = {
        criteresSuggeres: new Formulaire([
            new FormulaireItem('refcleintcri', {
                required: true,
                default: $stateParams.refcleint,
                readonly: () => ($stateParams.refcleint)
            }),
        ]),
        fonctions: {
            rechercheCollapsable: false,
            reinitialiserOuvrirCriteres: !$stateParams.refcleint,
            criteresSuggeresVisibles: !$stateParams.refcleint,
            effaceCriteres: true
        },
        pagination: new Pagination({
            nombreElementPage: 5,
            nbElementsPossibles: [5, 10, 15]
        }),
        colonnesVisibles: [
            { nom: 'focnom', largeur: 200 },
            { nom: 'focdatexp', largeur: 126 },
            { nom: 'focflgstu', largeur: 120 },
            { nom: 'intcod', largeur: 120 },
            { nom: 'intnom', largeur: 180 }
        ],
        formulaire: new Formulaire([
            new FormulaireItem('refcleint', { default: $stateParams.refcleint}),
            new FormulaireItem('focnom'),
            new FormulaireItem('focdatexp'),
            new FormulaireItem('focflgstu'),
            new FormulaireItem('intcleint')
        ]),
        multiOccurrenceOptionsEnfant: vm.fcaMultiOccurrenceOptions
    };

}
